(function (ws) {
    'use strict';
    ws.models.physicalProductsStatus = Backbone.Model.extend({

        /**
         * Initialize
         */
        initialize: function (options) {
            this.sapId = options.sapId;
            this.csrfToken = options.csrfToken;
        },

        /**
         * model URL
         */
        url: function () {
            return globals.path.api.westcon.orderStatus.replace('{sapId}', this.sapId) + '?CSRFToken=' + this.csrfToken;
        }
    });
})(westcon);
